import type { ElementType, HTMLAttributes } from 'react'
import type { TypeRole } from '../../styles/tokens'
import { cx } from '../cx'
import styles from './Text.module.css'

type TextProps = Omit<HTMLAttributes<HTMLElement>, 'style' | 'className'> & {
  as?:
    | 'p'
    | 'span'
    | 'div'
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'li'
    | 'dt'
    | 'dd'
    | 'figcaption'
    | 'strong'
    | 'em'
    | 'code'
  variant?: TypeRole
  tone?: 'text' | 'text-sub' | 'text-mute' | 'text-ghost'
  weight?: 'strong'
  numeric?: boolean
  className?: string
}

const defaultElement = {
  title: 'h1',
  heading: 'h2',
  prose: 'p',
} as const

export function Text({
  as,
  variant = 'ui',
  tone,
  weight,
  numeric,
  className,
  children,
  ...rest
}: TextProps) {
  const Tag: ElementType =
    as ??
    (variant === 'title' || variant === 'heading' || variant === 'prose'
      ? defaultElement[variant]
      : 'span')
  return (
    <Tag
      {...rest}
      className={cx(styles.text, className)}
      data-variant={variant}
      data-tone={tone}
      data-weight={weight}
      data-numeric={numeric ? '' : undefined}
    >
      {children}
    </Tag>
  )
}
